import { Link } from "react-router-dom";
import { AlertTriangle, Link2 } from "lucide-react";

import type { WeComModule } from "../api/wecomAppService";
import { useWeComModuleBound } from "../model/useWeComModuleBound";

const COPY: Record<WeComModule, { title: string; desc: string }> = {
  customer_service: {
    title: "需先绑定企业微信才能使用 AI 客服",
    desc: "AI 客服通过企业微信客服接待访客。绑定企业微信、接入客服账号后,访客发来的消息才会出现在这里。",
  },
  coaching: {
    title: "需先绑定企业微信才能使用员工练习",
    desc: "员工练习在企业微信里进行:派出的任务以卡片发到员工企业微信,员工在企业微信「工作台」打开练习。电脑浏览器里不能直接练习。",
  },
};

/**
 * 1005 老板拍板:客服舱 / 陪练舱上线前只在企业微信里用(不做网页试聊 / 电脑端练习),先把话写清楚。
 * 租户没绑定对应模块的企微应用时,页面顶部显著提示 +「去绑定」跳渠道管理。
 * 查不到(无权限 / 接口失败)时不显示 —— 宁可少提示,不误报。
 */
export function WeComRequiredBanner({ module }: { module: WeComModule }) {
  // 只在「确认没绑」时提示;查不到(undefined)不显示
  if (useWeComModuleBound(module) !== false) return null;
  const copy = COPY[module];
  return (
    <div
      role="alert"
      className="flex flex-wrap items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900 dark:border-amber-700/60 dark:bg-amber-950/40 dark:text-amber-100"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{copy.title}</p>
        <p className="mt-0.5 text-sm opacity-90">{copy.desc}</p>
      </div>
      <Link
        to="/channels"
        className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-amber-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-amber-700"
      >
        <Link2 className="h-4 w-4" />
        去绑定
      </Link>
    </div>
  );
}
